import React from 'react';
import { 
	func, 
	number,
	bool
} from 'prop-types';

export default class Container extends React.Component {
	static propTypes = {
		remaining : number,
		render : func,
		interval : number,
		notifyComplete : func,
		stop : bool
	}

	constructor(props) {
		super(props);
		this.timerId = null;
		this.prevTime = null;
		this.state = {
			remaining : props.remaining,
			maxTime : props.remaining,
		};
	}
    
    clear = ()=>{
    	if(this.timerId){
    		clearInterval(this.timerId);
    		this.timerId = null;
    		this.prevTime = null;
    	}
    }

    handleTimer = ()=>{
    	const currentTime = Date.now();
    	const elapsed = currentTime - this.prevTime;
    	const nextRemaining = this.state.remaining - elapsed;
    	if (nextRemaining <= 0) {
    		const {notifyComplete} = this.props;
    		notifyComplete && notifyComplete();
    		this.clear();
    		this.setState({ remaining: 0 });
    	} else {
    		this.prevTime = currentTime;
    		this.setState({ remaining: nextRemaining });
    	}
    }

    componentWillUnmount = ()=>{
    	this.clear();
    }
    
    componentDidMount = ()=>{
    	const {interval,remaining} = this.props;
    	this.prevTime = Date.now();
    	if(remaining) {
    		this.timerId = setInterval(this.handleTimer, interval);
    	}
    }
	
	componentDidUpdate = ()=>{
		const {stop} = this.props;
		if(stop){
			this.clear();
		}
	}
	
	render(){
    	const {render,interval,remaining,notifyComplete,stop,...other} = this.props;
    	return render({
    		remaining : this.state.remaining,
    		progress : Math.floor((this.state.maxTime - this.state.remaining)/ this.state.maxTime * 100)
    	},other);
	}
}
